
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ChevronDown } from "lucide-react";  // Using ChevronDown as an alternative

export const Hero = () => {
  const containerRef = useRef(null);
  const { scrollY } = useScroll();

  // Parallax effects
  const y = useTransform(scrollY, [0, 500], [0, -150]);
  const opacity = useTransform(scrollY, [0, 300], [1, 0]);

  // New scroll indicator animation
  const scrollIndicatorOpacity = useTransform(scrollY, [0, 150], [1, 0]);
  const scrollIndicatorY = useTransform(scrollY, [0, 150], [0, 20]);

  return (
    <motion.div
      ref={containerRef}
      className="relative min-h-screen overflow-hidden bg-white z-10"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Morphing shapes */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          className="absolute -left-64 -top-64 w-128 h-128 rounded-full bg-heaven-gold/10 blur-3xl"
          animate={{
            scale: [1, 1.2, 1],
            x: [0, 100, 0],
            y: [0, 50, 0]
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            repeatType: "reverse"
          }}
        />
        <motion.div
          className="absolute -right-64 -bottom-64 w-128 h-128 rounded-full bg-heaven-gold/10 blur-3xl"
          animate={{
            scale: [1.2, 1, 1.2],
            x: [0, -100, 0],
            y: [0, -50, 0]
          }}
          transition={{
            duration: 15,
            repeat: Infinity,
            repeatType: "reverse"
          }}
        />
      </div>

      <motion.div
        style={{ y, opacity }}
        className="relative z-10 container mx-auto px-4 pt-32 flex flex-col items-center justify-center text-center"
      >
        <motion.div
          className="w-full max-w-4xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.img
            src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos/tranparent%20logo.png"
            alt="Selah Logo"
            className="h-48 md:h-72 lg:h-96 mx-auto mb-8 object-contain"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{
              scale: 1,
              opacity: 1,
              filter: [
                "brightness(1) drop-shadow(0 0 20px rgba(212,175,55,0.2))",
                "brightness(1.1) drop-shadow(0 0 30px rgba(212,175,55,0.4))",
                "brightness(1) drop-shadow(0 0 20px rgba(212,175,55,0.2))"
              ]
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              repeatType: "reverse",
              ease: "easeInOut"
            }}
          />
          
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-playfair text-[#1A1F2C] mb-4">
              Discipleship in the{" "}
              <span className="text-heaven-gold">Digital Age</span>
            </h1>
            <div className="w-24 h-1 bg-heaven-gold mx-auto mt-6"></div>
          </div>
        </motion.div>
      </motion.div>
      
      {/* Scroll Down Indicator with fade out on scroll */}
      <motion.div 
        style={{ 
          opacity: scrollIndicatorOpacity,
          y: scrollIndicatorY
        }}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          delay: 1, 
          duration: 0.5,
        }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center text-gray-600 text-sm"
      >
        <span className="mb-1">Scroll Down</span>
        <ChevronDown className="h-5 w-5 text-heaven-gold animate-bounce" />
      </motion.div>
    </motion.div>
  );
};
